import React from 'react';
import PropTypes from 'prop-types';
import { UploadField } from '@navjobs/upload';

import { Button } from 'shared/components';

import { UserIconWithEdit } from '../';
import isBase64Image from '../../utils/isBase64Image';

import theme from './UserDetailsInfo.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  fullName: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  initials: PropTypes.string.isRequired,
  handleAvatarUpload: PropTypes.func,
  userReadPermissions: PropTypes.object.isRequired,
  userUpdatePermissions: PropTypes.object.isRequired,
};

const defaultProps = {
  avatar: '',
  handleAvatarUpload: () => null,
};

const changePhotoLabel = { id: 'MyAccount.Change.Avatar', defaultMessage: '** Change photo' };
const uploadPhotoLabel = { id: 'MyAccount.Upload.Avatar', defaultMessage: '** Upload photo' };

const UserDetailsInfo = ({
  intl,
  fullName,
  avatar,
  initials,
  handleAvatarUpload,
  userReadPermissions,
  userUpdatePermissions,
}) => (
  <div className={ theme.root }>
    <If condition={ userReadPermissions.canSeeAvatar }>
      <div className={ theme.userIconContainer }>
        <UserIconWithEdit
          imgData={ avatar }
          initials={ initials }
          className={ theme.userIcon }
          editable={ userUpdatePermissions.canUpdateAvatar }
        />
      </div>

      <If condition={ userUpdatePermissions.canUpdateAvatar && userUpdatePermissions.canUpdateUserAccount }>
        <div>
          <UploadField
            onFiles={ handleAvatarUpload }
            uploadProps={{ accept: '.jpg,.jpeg,.png' }}
            onChange={ e => e.target.value = '' }
          >
            <Button
              testId="avatar-upload-button"
              label={ isBase64Image(avatar) ? intl.formatMessage(changePhotoLabel) : intl.formatMessage(uploadPhotoLabel) }
              className={ theme.uploadImageMessage }
              size="small"
              buttonType="naked"
            />
          </UploadField>
        </div>
      </If>
    </If>

    <If condition={ userReadPermissions.canSeeName }>
      <div className={ theme.fullName }>
        { fullName }
      </div>
    </If>
  </div>
);

UserDetailsInfo.propTypes = propTypes;
UserDetailsInfo.defaultProps = defaultProps;

export default UserDetailsInfo;
